import script from "./VuetifyCurrencyInput.vue?vue&type=script&setup=true&lang=js"
export * from "./VuetifyCurrencyInput.vue?vue&type=script&setup=true&lang=js"

import "./VuetifyCurrencyInput.vue?vue&type=style&index=0&id=94492f42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94492f42"]])

export default __exports__